export const TYPO3_BASE_URL = 'https://staging.boyens-api.de/api/';

export const TYPO3_API_TIMEOUT = 2500;